import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = "/quinte-bca-logo.png";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qbca_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// If an ADMIN request fails with 401 while we have a stored token, the session is
// stale/expired (e.g. after a redeploy rotates the secret). Clear it and send
// the admin to the login screen with a clear message instead of a vague error.
// Scoped to admin-protected endpoints only — public endpoints (e.g. the captains
// password gate) legitimately return 401 and must not sign the admin out.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const hadToken = !!localStorage.getItem("qbca_token");
    const isAdminEndpoint = url.includes("/admin/") || url.includes("/auth/me");
    if (status === 401 && hadToken && isAdminEndpoint) {
      localStorage.removeItem("qbca_token");
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.assign("/admin/login?expired=1");
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (url) => {
  if (!url) return "";
  // Serve Cloudinary images in a modern format (WebP/AVIF) at auto quality — big speed win.
  if (
    url.includes("res.cloudinary.com") &&
    url.includes("/image/upload/") &&
    !url.includes("/image/upload/f_auto") &&
    !url.toLowerCase().endsWith(".pdf")
  ) {
    return url.replace("/image/upload/", "/image/upload/f_auto,q_auto/");
  }
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
